const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export default {
  login: () => `${apiBaseUrl}/auth/login`,
  signup: () => `${apiBaseUrl}/auth/signup`,
  me: () => `${apiBaseUrl}/auth/me`,
  changePassword: () => `${apiBaseUrl}/auth/change-password`,
  channels: (page?: number, limit?: number, projectId?: string, q?: string, sortBy?: string, sortOrder?: string) => {
    const params = new URLSearchParams()
    if (page) params.append('page', page.toString())
    if (limit) params.append('limit', limit.toString())
    if (projectId) params.append('projectId', projectId)
    if (q) params.append('q', q)
    if (sortBy) params.append('sortBy', sortBy)
    if (sortOrder) params.append('sortOrder', sortOrder)
    const query = params.toString()
    return `${apiBaseUrl}/channels${query ? `?${query}` : ''}`
  },
  channel: (id: string) => `${apiBaseUrl}/channels/${id}`,
  bulkCreateChannels: () => `${apiBaseUrl}/channels/bulk`,
  // Note: Email template editing moved to project level
  searchChannels: (query: string) => `${apiBaseUrl}/channels/search?q=${encodeURIComponent(query)}`,
  allUsers: () => `${apiBaseUrl}/users`,
  user: (id: string) => `${apiBaseUrl}/users/${id}`,
  users: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/users/?page=${page}&pageSize=${pageSize}`,
  projects: () => `${apiBaseUrl}/projects`,
  project: (id: string) => `${apiBaseUrl}/projects/${id}`,
  projectEmails: (projectId: string) => `${apiBaseUrl}/projects/${projectId}/emails`,
  projectTemplates: (projectId: string) => `${apiBaseUrl}/projects/${projectId}/templates`,
  projectEmailTemplate: (projectId: string) => `${apiBaseUrl}/projects/${projectId}/email-template`,
  pushProjectTemplates: (projectId: string) => `${apiBaseUrl}/projects/${projectId}/push-templates`,
  processPendingEmails: () => `${apiBaseUrl}/cron/process-pending-emails`,
  emailChannelHistory: (page?: number, limit?: number, projectId?: string, channelId?: string) => {
    const params = new URLSearchParams()
    if (page) params.append('page', page.toString())
    if (limit) params.append('limit', limit.toString())
    if (projectId) params.append('projectId', projectId)
    if (channelId) params.append('channelId', channelId)
    const query = params.toString()
    return `${apiBaseUrl}/cron/email-channel-history${query ? `?${query}` : ''}`
  },
  emails: (page?: number, limit?: number, projectId?: string, status?: string) => {
    const params = new URLSearchParams()
    if (page) params.append('page', page.toString())
    if (limit) params.append('limit', limit.toString())
    if (projectId) params.append('projectId', projectId)
    if (status) params.append('status', status)
    const query = params.toString()
    return `${apiBaseUrl}/emails${query ? `?${query}` : ''}`
  },
  // Legacy endpoints (kept for backward compatibility if needed)
  projectsOld: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/projects/?page=${page}&pageSize=${pageSize}`,
  avatars: () => `${apiBaseUrl}/avatars`,
  adminUsers: () => `${apiBaseUrl}/admin/users`,
  pushTemplateErrors: (page?: number, limit?: number, projectId?: string, errorType?: string, resolved?: boolean) => {
    const params = new URLSearchParams()
    if (page) params.append('page', page.toString())
    if (limit) params.append('limit', limit.toString())
    if (projectId) params.append('projectId', projectId)
    if (errorType) params.append('errorType', errorType)
    if (resolved !== undefined) params.append('resolved', resolved.toString())
    const query = params.toString()
    return `${apiBaseUrl}/push-template-errors${query ? `?${query}` : ''}`
  },
  markErrorAsResolved: (errorId: string) => `${apiBaseUrl}/push-template-errors/${errorId}/resolve`,
  markChannelErrorsAsResolved: (channelId: string) => `${apiBaseUrl}/push-template-errors/channels/${channelId}/resolve`,
}
